//also use this for adding the note title
import { useRef } from "react";
import styles from "../../Styles/InputField.module.css";

const InputField = ({ label, input, type = "text", initialValue = "" }) => {
  const inputRef = useRef();
  const inputHandler = () => {
    input(inputRef.current.value);
  };
  const initialTitleValue = initialValue !== "" ? initialValue : null;
  return (
    <input
      autoComplete="on"
      type={type}
      className={styles.input__field}
      placeholder={label}
      onChange={inputHandler}
      ref={inputRef}
      defaultValue={initialTitleValue}
    />
  );
};
export default InputField;
